import { jsxs as _jsxs } from "react/jsx-runtime";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/result/style";
import _Result from "antd/lib/result";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import CardContainer from 'components/layout/CardContainer';
import Link from 'next/link';

var NotFoundContent = function NotFoundContent(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'This is a private page' : _ref$title,
      _ref$subTitle = _ref.subTitle,
      subTitle = _ref$subTitle === void 0 ? 'Sorry, you need to be logged to view this page.' : _ref$subTitle;
  useEffect(function () {
    console.log('Effect NotFoundContent');
  }, []);
  return /*#__PURE__*/_jsxs(CardContainer, {
    children: [/*#__PURE__*/_jsx(_Result, {
      status: "warning",
      title: title,
      subTitle: subTitle
    }), /*#__PURE__*/_jsx("div", {
      className: "textCenter",
      children: /*#__PURE__*/_jsx(_Button, {
        type: "primary",
        children: /*#__PURE__*/_jsx(Link, {
          href: '/',
          children: "Back Home"
        })
      })
    })]
  });
};

export default NotFoundContent;